<nav class="navbar bg-black navbar-dark navbar-expand-lg d-none d-lg-flex px-2">
  <a class="navbar-brand py-0" [routerLink]="['/']" routerLinkActive="router-link-active">
    <img class="ms-1 h-100" src="assets/images/Logos/Redbullslogo.svg" draggable="false" />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav ms-auto" #greedyNav>
        <li class="nav-item active">
          <a class="nav-link" [routerLink]="['/']" routerLinkActive="router-link-active">{{ 'nav.home' | translate }}</a>
        </li>

        <li class="nav-item active">
          <a class="nav-link" [routerLink]="['/rewards']" routerLinkActive="router-link-active">{{
            'nav.rewards' | translate
          }}</a>
        </li>

        <li class="nav-item active">
          <a class="nav-link" [routerLink]="['/games']" routerLinkActive="router-link-active">{{ 'nav.games' | translate }}</a>
        </li>

        <li class="nav-item active">
          <a class="nav-link" [routerLink]="['/rewards/wallet']" routerLinkActive="router-link-active">{{
            'nav.wallet' | translate
          }}</a>
        </li>

        <li class="nav-item active">
          <a class="nav-link" [routerLink]="['/news']" routerLinkActive="router-link-active">{{ 'nav.news' | translate }}</a>
        </li>
      </ul>
    </div>
    <!-- Right Side Content -->
    <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0">
      <div class="balance d-flex text-white fw-bold align-items-center">
        <div *ngIf="loyaltyPointsCard$" class="glass-bg gloss-black d-flex align-items-center me-3">
          <span class="icon material-symbols-outlined font-size-20">loyalty</span>
          <span class="ps-1 font-size-14 no-wrap">{{ loyaltyPointsCard$ | async | FortressCurrencyPipe: 'PTS' }}</span>
        </div>

        <div *ngIf="combinedCard$" class="glass-bg gloss-black d-flex align-items-center me-3">
          <span class="icon material-symbols-outlined font-size-20">money_bag</span>
          <span class="ps-1 font-size-14"> {{ combinedCard$ | async | FortressCurrencyPipe }}</span>
        </div>
      </div>

      <button
        class="nav-link btn d-flex align-items-center mx-2 px-0 justify-content-end"
        (click)="isNavOpen = !isNavOpen"
        id="namedropdown"
        attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
        tabindex="-1"
        focusTab
      >
        <i class="material-symbols-outlined menu-icon">dehaze</i>
      </button>
    </div>
  </div>
</nav>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div class="right-nav-menu" [@rightNavAnimation]="isNavOpen ? 'open' : 'close'" [ngClass]="{ open: isNavOpen }">
  <div class="d-flex flex-column">
    <!-- Close Button -->
    <button
      type="button"
      class="btn-close close-button position-absolute"
      (click)="isNavOpen = false"
      aria-label="Close"
    ></button>

    <!-- Club Logo -->
    <div class="d-flex align-items-center justify-content-start brand-logo">
      <img class="brand" src="assets/images/Logos/Redbullslogo.svg" draggable="false" />
    </div>

    <div class="modal-content d-flex gap-2 rounded-0">
      <div class="modal-header w-100 d-flex align-items-center justify-content-between mt-3">
        <div class="header-left">
          <div
            class="card-name fw-bold text-uppercase font-size-16 font-page-heading"
            *ngIf="memberDetails$ | async as memberDetails"
          >
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </div>

          <!--eCash Button -->
          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.nav.ecash'">
            <div class="ecash-button-account mt-3">
              <fgb-ecash-button [showCardExpiry]="false"></fgb-ecash-button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- <fgb-card-select></fgb-card-select> -->

    <div class="right-nav-menu-list mt-3">
      <!-- Nav Buttons -->
      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/account']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.account' | translate }}</div>
      </a>

      <a
        href="{{ 'nav.account.manager.url' | translate }}"
        target="_blank"
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
      >
        <div class="nav-text">{{ 'nav.account.manager' | translate }}</div>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/challenges']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
      </a>

      <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.nav.ecash'">
        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/ecash']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.ecash' | translate }}</div>
        </a>
      </ng-container>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/earn']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.earn' | translate }}</div>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/rewards/wallet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.wallet' | translate }}</div>
      </a>

      <a class="right-nav-menu-item" data-bs-dismiss="offcanvas" href="{{ ticketTradeLink }}" target="_blank">
        <div class="nav-text">{{ 'nav.ticket.trade' | translate }}</div>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/faqs']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.faq' | translate }}</div>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/terms']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.terms' | translate }}</div>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/contact-us']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/sweepstakeofficialrules']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-text">{{ 'nav.sweepstakes.official.rules' | translate }}</div>
      </a>

      <a class="log-out" data-bs-dismiss="offcanvas" (click)="logout()">
        <i class="material-icons">logout</i>
        <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
      </a>
    </div>
  </div>
</div>
